export const roleConstants = {
	ORDER_REVIEW: 'Order Reviewer',
	PURCHASE_ORDER_APPROVER: 'Purchase Order Approver',
	LOTCHECK_COORDINATOR: 'Lotcheck Coordinator',
	MARKETING_EVENTS_POWER_USER:'Marketing Events Power User',
	MARKETING_EVENTS_TEAM_MEMBER: 'Marketing Events Team Member',
	MARKETING_EVENTS_SUPPORT: 'Marketing Events Support',
	MARKETING_EVENTS_LEAD: 'Marketing Events Lead'
};

export const roleTypeCodes = {
	INTERNAL: 'INTERNAL',
	EXTERNAL: 'EXTERNAL',
};
